var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';
import { observable, action, computed } from 'mobx';
import { Modal } from '@app/Components/Modal/Modal';
export var StatusCell = /** @class */ (function (_super) {
    __extends(StatusCell, _super);
    function StatusCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isEditMode = false;
        _this._selectedOptionsValue = null;
        _this.statuses = ['Approved', 'Draft'];
        return _this;
    }
    StatusCell.prototype.componentDidUpdate = function () {
        var status = this.props.status;
        var currentValue = this._selectedOptionsValue;
        if (!currentValue)
            this._setSelectedOption({ value: status, label: status });
    };
    StatusCell.prototype._handleEditClick = function () {
        this._isEditMode = true;
    };
    StatusCell.prototype._handleSaveClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, onChangeStatusHandler, currentValue, status;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = (_a = this.props, _a.itemId), onChangeStatusHandler = _a.onChangeStatusHandler;
                        this._isEditMode = false;
                        currentValue = this._selectedOptionsValue;
                        if (!currentValue)
                            return [2 /*return*/];
                        status = currentValue.value;
                        return [4 /*yield*/, onChangeStatusHandler(id, status)];
                    case 1:
                        _b.sent();
                        this.props.onSave();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatusCell.prototype._handleCancelClick = function () {
        this._isEditMode = false;
    };
    StatusCell.prototype._toggle = function () {
        this._isEditMode = !this._isEditMode;
    };
    StatusCell.prototype._setSelectedOption = function (selectedValue) {
        this._selectedOptionsValue = selectedValue;
    };
    Object.defineProperty(StatusCell.prototype, "_isSaveDisabled", {
        get: function () {
            var status = this.props.status;
            var currentValue = this._selectedOptionsValue;
            if (!currentValue)
                return false;
            return currentValue.value !== status;
        },
        enumerable: false,
        configurable: true
    });
    StatusCell.prototype.render = function () {
        var _a;
        var _this = this;
        var status = (_a = this.props, _a.status), itemCode = _a.itemCode, excludedStatuses = _a.excludedStatuses;
        var letter = status.charAt(0);
        var statuses = excludedStatuses ? this.statuses.filter(function (st) { return !excludedStatuses.includes(st); }) : this.statuses;
        var options = statuses.map(function (status) { return ({ value: status, label: status }); });
        return (React.createElement("div", { onDoubleClick: this._handleEditClick, title: itemCode, style: { cursor: 'pointer' } },
            letter,
            this._isEditMode && (React.createElement(Modal, { isOpen: this._isEditMode, headerTitle: 'Change Status' + itemCode, toggle: this._toggle, maxWidth: "400px", footerbuttons: this._getFooterButtons() },
                React.createElement(Select, { options: options, value: this._selectedOptionsValue, onChange: function (selectedValue) { return _this._setSelectedOption(selectedValue); } })))));
    };
    StatusCell.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._handleSaveClick,
                disabled: !this._isSaveDisabled,
                title: 'Save'
            },
            {
                onClick: this._handleCancelClick,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], StatusCell.prototype, "_isEditMode", void 0);
    __decorate([
        observable
    ], StatusCell.prototype, "_selectedOptionsValue", void 0);
    __decorate([
        action.bound
    ], StatusCell.prototype, "_handleEditClick", null);
    __decorate([
        action.bound
    ], StatusCell.prototype, "_handleSaveClick", null);
    __decorate([
        action.bound
    ], StatusCell.prototype, "_handleCancelClick", null);
    __decorate([
        action.bound
    ], StatusCell.prototype, "_toggle", null);
    __decorate([
        action.bound
    ], StatusCell.prototype, "_setSelectedOption", null);
    __decorate([
        computed
    ], StatusCell.prototype, "_isSaveDisabled", null);
    StatusCell = __decorate([
        observer
    ], StatusCell);
    return StatusCell;
}(React.PureComponent));
